import React, {useEffect, useRef, useState} from 'react';
import {FormPageRoot, Img_CreateAlbum_FormDialog, ThemedButton, ThemedDialog, ThemedInput} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {checkNullArr, checkNullStr, getDefStr, getJsonValue, isBoolTrue, isJsonValueTrue, vhToPx} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, getSubdomainSessionData, getUserSessionField, isCurrUserRoleAdmin, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {INPUT_FILE_MAX_SIZE, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls,} from "../../../config/AppConfig";
import {Avatar, Flexbox, Image, Label, MsgBox, Select} from "../../../../common/fusion-ui";
import {Constants, CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../../../common/CommonConfig";

const Image_Recom_FormPage = React.memo(({asPanel = false, redirectUrl}) => {
    const TAG = "Image_Recom_FormPage";

    const moduleName = Modules.Images;
    const FormFields = ModuleFieldsData[moduleName];
    const NAME_KEY = 'name';

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;

    const Fields = {
        canShowAddForm: 'canShowAddForm',

        imagesLoading: 'imagesLoading',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',

        albums: 'albums',
        selectedAlbum: 'selectedAlbum',
        showAlbumLoading: 'showAlbumLoading',

        openCreateAlbumDialog: 'openCreateAlbumDialog',

        showSuccessDialog: 'showSuccessDialog',
        successDialogOnHide: 'successDialogOnHide',
    };
    const [fieldsData, setFieldsData] = useState({});
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});
    const imgChooserInputRef = useRef(null);

    useEffect(() => {
        // setFormData({});
        if (!checkNullStr(getField(Fields.isDataFound))) {
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);
            fetchAlbums();
        }
    }, []);

    return (<>
        {isBoolTrue(asPanel) ? createForm() : createFormPage()}
        {createAlbumFormDialog()}
        {createSuccessDialog()}
    </>)

    function createFormPage() {
        return <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            addPageTitle={getTabTitle()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            md={6}>
            {createForm()}
        </FormPageRoot>
    }

    function createForm() {
        return <div>
            {/*album*/}
            <Flexbox className={''} justifyAt={'between'} alignAt={'center'}>
                {/*album-select*/}
                <Select
                    id={FormFields.albumName.column}
                    wrapperClassName={`w-100`}
                    className={`w-100 rounded-3 py-2`}
                    innerWrapperClassName={'w-100'}
                    labelClassName={'w-100 text-input-label'}
                    variant={'primary'}
                    justifyAt={'start'}
                    // style={{height: '32px'}}
                    labelColor={theme.text40}
                    wrap={'wrap'}
                    label={'Select an album'}
                    placeholder={'Select an album'}
                    textKey={'text'}
                    idKey={'id'}
                    required={true}
                    options={getField(Fields.albums, [])}
                    defOption={getFormField(FormFields.albumId)}
                    showLoader={isFieldTrue(Fields.showAlbumLoading)}
                    showRefresh={true}
                    onRefresh={() => fetchAlbums()}
                    onChange={(e, text, value) => {
                        log('album.Select.onChange::text:', text, "value:", value);
                        updateFormField(FormFields.albumId, value);
                        updateFormField(FormFields.albumName, text);
                    }}
                />

                {/*create-album btn*/}
                {isCurrUserRoleAdmin() && <ThemedButton
                    className={'rounded-2 w-auto px-2 py-1 text-nowrap fs-sm'}
                    text={'Create new album'}
                    outlined={true}
                    ml={3}
                    mt={3}
                    variant={theme.primaryBlue}
                    onClick={() => updateField(Fields.openCreateAlbumDialog, true)}
                />}
            </Flexbox>

            {/*image*/}
            <div className={'my-3'}>
                <Avatar
                    wrapperClassName={'w-100'}
                    className={''}
                    labelClassName={'w-100x pb-2 text-startxx'}
                    justifyAt={'center'}
                    alignAt={'start'}
                    wrap={'wrap'}
                    direction={'column'}
                    label={FormFields.title.titleAlt}
                    labelColor={theme.text40}
                    accept={'.jpg, .jpeg, .png'}
                    editTooltip={`Edit (.jpg, .jpeg, .png)`}
                    showEdit={true}
                    showDelete={true}
                    circular={false}
                    showFullPreviewDialog={true}
                    defAvatarImg={Constants.imgVector}
                    editSize={'21px'}
                    width={'100px'}
                    height={'140px'}
                    maxSize={INPUT_FILE_MAX_SIZE}
                    onChange={(e, file, path, name, ext) => {
                        //log('Avatar.title.onChange.name:', name);
                        updateFormField(FormFields.title, file);
                        updateFormField(FormFields.fileExt, ext);
                    }}
                    onInvalidFormat={(e, name) => {
                        toast(`Invalid file format. File must be jpg, jpeg or png`, CssVariant.danger);
                    }}
                    onSizeExceeded={() => {
                        toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                    }}>{getFormField(FormFields.title)}</Avatar>
            </div>


            {/*by*/}
            <ThemedInput
                label={"Recommended by"}
                placeholder={"Recommended by"}
                value={getUserSessionField('fullName')}
                readOnly={true}
            />

            {/*footer*/}
            <div className={'mt-3'}>
                {/*msg-box*/}
                {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                    {getField(Fields.panelMsg)}
                </MsgBox>}

                {/*controls*/}
                <Flexbox className={'mt-2'} justifyAt={'center'} alignAt={'center'}>
                    <ThemedButton
                        className={'rounded-2 w-auto px-4 py-1'}
                        text={isFieldTrue(Fields.submitBtn_AsLoading) ? 'Uploading...' : 'Upload'}
                        variant={theme.primaryBlue}
                        hoverBgColor={theme.primaryBlueDark}
                        loadingWidth={'auto'}
                        asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                        disabled={isFieldTrue(Fields.submitBtn_disabled)}
                        onClick={handleSubmit}
                    />
                </Flexbox>
            </div>
        </div>
    }

    function createSuccessDialog() {
        return <ThemedDialog
            className={"rounded-6 p-0 m-0"}
            titleClassName={'fs-lg mb-2'}
            // open={true}
            open={isFieldTrue(Fields.showSuccessDialog)}
            title={"Thanks"}
            showClose={true}
            showFooter={false}
            closeOnEscape={true}
            closeOnOutsideClick={true}
            onHide={() => {
                const onHide = getField(Fields.successDialogOnHide);
                if (onHide) onHide();
                // updateField(Fields.showSuccessDialog, false);
            }}
        >
            <div className={'px-3'}>
                <div className={'m-0 p-0 pt-1 px-2 d-none-smx h-100 auth-img-wrapper w-100'}>
                    <Image
                        wrapperClassName={`w-100 rounded-6 overflow-hidden select-none`}
                        className={`auth-ra-img transition-sm`}
                        src={"https://cdn.pixabay.com/photo/2016/11/07/00/49/thanks-1804597_1280.jpg"}
                        // src={"https://cdn.pixabay.com/photo/2020/04/22/11/59/thank-you-5077738_1280.jpg"}
                        width={'100%'}
                        height={vhToPx('60vh') + 'px'}
                        objectFit={'cover'}
                        disableDrag={true}
                    />
                </div>

                <div>
                    <div className={'w-100 d-flex jc-center'}>
                        <Label className={'text-wrap fw-semi-bold mt-3 fs-normal'} color={theme.text80} textAt={'center'}>
                            {getDefStr(getField(Fields.panelMsg), Messages.formDataSaveSuccess)}
                        </Label>
                    </div>
                    <div className={'w-100 d-flex jc-center'}>
                        <Label className={'text-wrap fw-bold fs-xl'} color={theme.primaryBlue} textAt={'center'}>
                            {"Many thanks for your kind recommendation."}
                        </Label>
                    </div>
                </div>
            </div>
        </ThemedDialog>
    }

    function createAlbumFormDialog() {
        return <Img_CreateAlbum_FormDialog
            open={isFieldTrue(Fields.openCreateAlbumDialog)}
            onHide={() => {
                // updateField(Fields.openCreateAlbumDialog, false);
            }}
            onCancel={() => {
                updateField(Fields.openCreateAlbumDialog, false);
            }}
            onSuccess={(fetchedData, message) => {
                updateField(Fields.openCreateAlbumDialog, false);
                // log('createAlbumFormDialog.onSuccess.fetchedData:', fetchedData, 'message:', message);
                fetchAlbums();
            }}
        />
    }

    //======================UI Functions end=====================

    //======================Request Functions start=====================
    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    fromRecommendPage: true,
                    browserUrl: window.location.href,
                    formData: formData,
                    subdomainData: getSubdomainSessionData(),
                };
                sendRequest({
                    reqUrl: ReqUrls.img__recomPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);

                            updateField(Fields.successDialogOnHide, (() => {
                                updateField(Fields.showSuccessDialog, false);
                                if (redirectUrl != -1) window.location.href = getDefStr(redirectUrl, ModuleRouteUrls[moduleName]);
                            }));
                            updateField(Fields.showSuccessDialog, true);
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchAlbums(selectedId = '', selectedName = '') {
        const fun = 'fetchAlbums:';
        try {
            updateField(Fields.showAlbumLoading, true);
            updateField(Fields.albums, []);
            updateFormField(FormFields.albumName, null);
            updateFormField(FormFields.albumId, null);
            // Fetch the albums
            sendRequest({
                reqUrl: ReqUrls.img__fetch_Albums,
                onFetched: ((fetchedData) => {
                    // log(fun, 'doc__fetch_Albums.fetchedData:', fetchedData);
                    const albums = getJsonValue(fetchedData, 'data');
                    const success = checkNullArr(albums);
                    if (success) {
                        updateField(Fields.albums, albums);
                        if (checkNullStr(selectedId)) {
                            updateFormField(FormFields.albumId, selectedId);
                            updateFormField(FormFields.albumName, selectedName);
                        }
                        // log(fun, 'doc__fetch_Albums.selectedId:', selectedId, 'selectedName:', selectedName);
                    } else {
                        toast("No albums found, please create a album first from Images Page.", CssVariant.danger);
                    }
                    updateField(Fields.showAlbumLoading, false);
                }),
                onError: ((error) => {
                    toast("Couldn't load albums, please refresh again!", CssVariant.danger);
                    logErr(fun, error);
                    updateField(Fields.showAlbumLoading, false);
                }),
            });
        } catch (error) {
            toast("Couldn't load albums, please refresh again!", CssVariant.danger);
            logErr(error);
            updateField(Fields.showAlbumLoading, false);
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            FormFields.albumName,
            FormFields.title,
        ];

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.titleAlt}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function clearImgInput() {
        try {
            if (imgChooserInputRef.current) {
                imgChooserInputRef.current.value = ""; // Clear the file input
            }
        } catch (error) {
            logErr('clearImgInput.error:', error);
        }
    }

    function getTabTitle() {
        return `Recommend Images`;
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Image_Recom_FormPage;
